var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col1",class:_vm.classWrap},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"inner"},[_vm._t("container")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }